// extracted by mini-css-extract-plugin
module.exports = {"mobile":"MobileHeader_mobile__vvW6t","menu-container":"MobileHeader_menu-container__Oqxdw","loading":"MobileHeader_loading__jCkhH"};